import { AlertCircleIcon } from 'lucide-react'
import { useErrorBoundary } from 'react-error-boundary'
import { AlertAction } from '@/components/sv/alert-action'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

export const ErrorBoundaryOverlay = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { resetBoundary } = useErrorBoundary()
  return (
    <div className="relative">
      <div className="absolute inset-0 z-10 bg-radial from-destructive/10 to-transparent to-70% flex items-center justify-center">
        <Alert className="max-w-md shadow-sm">
          <AlertCircleIcon className="text-destructive!" />
          <AlertTitle>Something went wrong</AlertTitle>
          <AlertDescription>
            Please try again later or contact support if the issue persists.
          </AlertDescription>
          <AlertAction>
            <Button
              variant="destructive"
              size="xs"
              onClick={() => resetBoundary?.()}
            >
              Try again
            </Button>
          </AlertAction>
        </Alert>
      </div>
      <div className="pointer-events-none">{children}</div>
    </div>
  )
}
